import React from 'react';
import './List.scss';
import './ListItem.scss';

import ListItem from "./ListItem";
import {ReactComponent as Spinner} from '../../assets/icons/spinner.svg';
import {useSelector} from "react-redux";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const List = props => {
    const {
        pending,
        items,
        columnsTitles,
        columnsSources,
        columnsWidths,
        selectMethod,
        editMethod,
        deleteMethod,
        booleanColumns,
        dateColumns,
        dateAndTimeColumns,
        selectedItem,
        all,
        customButtonText,
        customButtonMethod,
        pagination,
        getItemsMethod,
        highlight
    } = props;
    const { t } = useSelector(selector);
    const actionButtons = !!(editMethod || deleteMethod || (customButtonText && customButtonMethod));

    let paginationNavItems = [];
    if(pagination) {
        for(let i = 1; i <= pagination.pageCount; i++) {
            paginationNavItems.push(i);
        }
    }

    if(pending) {
        return <div className='noData'><Spinner /></div>;
    } else if (!items.length) {
        return <div className='noData'>{t.gettext('No data available')}</div>
    } else {
        return (
            <ul className='List'>
                <li className='listHeader'>
                    {columnsTitles.map((title, index) => (
                        <div
                            key={index}
                            className='listHeaderCell'
                            style={{width: actionButtons
                                ? `calc(${columnsWidths[index]} - ${(!editMethod || !deleteMethod) && !customButtonText && !customButtonMethod 
                                    ? 50 / columnsWidths.length 
                                    : 145 / columnsWidths.length
                                }px)`
                                : columnsWidths[index]
                            }}
                        >
                            {t.gettext(title)}
                        </div>
                    ))}
                </li>
                <div className='listItems'>
                    {all &&
                        <li
                            className={`
                                ListItem 
                                ${selectMethod ? 'ListItem--selectable' : ''} 
                                ${!selectedItem ? 'ListItem--selected' : ''}
                            `}
                            onClick={() => selectMethod(null)}
                        >
                            <div className='listItemCell'>
                                {t.gettext('All')}
                            </div>
                        </li>
                    }
                    {items.map((item, index) => (
                        <ListItem
                            key={index}
                            item={item}
                            columnsSources={columnsSources}
                            columnsWidths={columnsWidths}
                            actionButtons={actionButtons}
                            selectMethod={selectMethod}
                            editMethod={editMethod}
                            deleteMethod={deleteMethod}
                            booleanColumns={booleanColumns}
                            dateColumns={dateColumns}
                            dateAndTimeColumns={dateAndTimeColumns}
                            selected={selectedItem === item.id}
                            customButtonText={customButtonText}
                            customButtonMethod={customButtonMethod}
                            highlight={highlight}
                        />
                    ))}
                    {!!pagination &&
                        <li className='paginationRow'>
                            <div className='paginationInfo'>
                                <div className='paginationInfoText'>{t.gettext('Displaying')}</div>
                                <div className='paginationInfoText'>{items.length}</div>
                                <div className='paginationInfoText'>{t.gettext('out of')}</div>
                                <div className='paginationInfoText'>{pagination.itemsCount}</div>
                                <div className='paginationInfoText'>{t.gettext('records')}</div>
                            </div>
                            <div className='paginationNav'>
                                <div
                                    className={`paginationNavItem ${pagination.page === 1 
                                        ? 'paginationNavItem--disabled' 
                                        : ''
                                    }`}
                                    onClick={() => pagination.page !== 1 ? getItemsMethod(pagination.page - 1) : null}
                                >
                                    {t.gettext('Prev')}
                                </div>
                                {paginationNavItems.map(navItem => (
                                    <div
                                        key={navItem}
                                        className={`paginationNavItem ${pagination.page === navItem 
                                            ? 'paginationNavItem--active' 
                                            : ''
                                        }`}
                                        onClick={() => pagination.page !== navItem ? getItemsMethod(navItem) : null}
                                    >
                                        {navItem}
                                    </div>
                                ))}
                                <div
                                    className={`paginationNavItem ${pagination.page === pagination.pageCount 
                                        ? 'paginationNavItem--disabled' 
                                        : ''
                                    }`}
                                    onClick={() => pagination.page !== pagination.pageCount ? getItemsMethod(pagination.page + 1) : null}
                                >
                                    {t.gettext('Next')}
                                </div>
                            </div>
                        </li>
                    }
                </div>
            </ul>
        );
    }
};

export default List;
